import { render, staticRenderFns } from "./AbroadZhanhuiList.vue?vue&type=template&id=5fa842a4&scoped=true"
import script from "./AbroadZhanhuiList.vue?vue&type=script&lang=js"
export * from "./AbroadZhanhuiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa842a4",
  null
  
)

export default component.exports